import axios from "axios";

const token =
  typeof document === "undefined"
    ? ""
    : document.getElementsByName("csrf-token")[0].content;
const instance = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-CSRF-Token": token,
  },
  responseType: "json",
});

export default instance;
